module.exports = __webpack_public_path__ + "img/wales.2.84dd5fd.jpg";